import React from 'react';

import { useGlobalContext } from '../../context/GlobalContext';
import AdminDashboard from './AdminDashboard';
import MemberDashboard from './MemberDashboard/MemberDashboard';
import OwnerDashboard from './OwnerDashboard/OwnerDashboard';

const MSL_DIVISIONS = ['Médical'];
const MEMBER_TILES_DIVISIONS = ['DAP', 'Ventes', 'Marché', 'Marchés'];
const LEGACY_ADMIN_DIVISIONS = ['Marketing', 'Finances', 'RH', 'Office'];

function resolveOwnerDashboardView(divisions = []) {
  if (divisions.some((division) => MSL_DIVISIONS.includes(division))) {
    return 'msl';
  }

  if (divisions.some((division) => MEMBER_TILES_DIVISIONS.includes(division))) {
    return 'member';
  }

  if (divisions.some((division) => LEGACY_ADMIN_DIVISIONS.includes(division))) {
    return 'legacy';
  }

  return 'member';
}

export default function OwnerDashboardSelector() {
  const [context] = useGlobalContext();
  const divisions = context.auth.userAuth?.division || [];
  const view = resolveOwnerDashboardView(divisions);

  if (view === 'msl') {
    return <OwnerDashboard />;
  }

  if (view === 'legacy') {
    return <AdminDashboard />;
  }

  return <MemberDashboard />;
}
